module.exports = __webpack_public_path__ + "static/chapel01-a509cf8b58faa70d7e93182ada5537c5.jpg";